import { css, Theme } from '@emotion/react'

export const button = () => css`
  position: absolute;
  right: 0;
`

export const wrapper = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing(2)};
  padding: ${theme.spacing(2)};
  margin: ${theme.spacing(2, 2, 0)};
  background-color: ${theme.colors.yellow};
  color: ${theme.colors.black};
  border: 1px solid ${theme.colors.yellowHover};
  border-radius: ${theme.spacing(1)};
`

export const buttons = (theme: Theme) => css`
  display: flex;
  gap: ${theme.spacing(1)};
`
